import { render, staticRenderFns } from "./TemplateEventsCategoryPieChart.vue?vue&type=template&id=118a6090&scoped=true&"
import script from "./TemplateEventsCategoryPieChart.vue?vue&type=script&lang=js&"
export * from "./TemplateEventsCategoryPieChart.vue?vue&type=script&lang=js&"
import style0 from "./TemplateEventsCategoryPieChart.vue?vue&type=style&index=0&id=118a6090&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "118a6090",
  null
  
)

export default component.exports